import React from 'react';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../partners/useStewardshipFilter';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { event_networkId, tags_partner } from '../../../utils/query-helpers';

export default function InvitedToEvent(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly } = props;

  const stewardshipFilter = useStewardshipFilter();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfInvitations',
            relation: 'invitations',
            $where: {
              eventId: {
                $null: false
              },
              // ...event_networkId(network),
              event: {
                $where: {
                  site: {
                    $where: {
                      state: {
                        $ilike: state
                      }
                    }
                  }
                }
              },
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_partner(),
          state: {
            $ilike: state
          },
          // $or: stewardshipFilter
        },
        $having: {
          numberOfInvitations: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  const newUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfInvitations',
            relation: 'invitations',
            $where: {
              eventId: {
                $null: false
              },
              // ...event_networkId(network),
              event: {
                $where: {
                  site: {
                    $where: {
                      state: {
                        $ilike: state
                      }
                    }
                  }
                }
              },
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_partner(),
          state: {
            $ilike: state
          },
          // $or: stewardshipFilter
        },
        $having: {
          numberOfInvitations: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Invited to Event"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Invited to Event"
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
